import { render, staticRenderFns } from "./index-sbsyqk.vue?vue&type=template&id=5c8edf9e&scoped=true&"
import script from "./index-sbsyqk.vue?vue&type=script&lang=js&"
export * from "./index-sbsyqk.vue?vue&type=script&lang=js&"
import style0 from "./index-sbsyqk.vue?vue&type=style&index=0&id=5c8edf9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8edf9e",
  null
  
)

export default component.exports